// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { recentWishListsStyles } from "@steiner/Overrides/Widgets/Common/RecentWishLists";
import { css } from "styled-components";


recentWishListsStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: calc(100% - 20px);
            margin: 0;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
}